import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { RelatedToType } from 'app/shared/enums';
import { Contact } from 'app/modules/contacts/contacts.types';
import { Company } from 'app/modules/companies/companies.types';
import { Project, Property } from 'app/modules/projects/projects.types';
@Component({
  selector: 'app-similar-items-list',
  templateUrl: './similar-items-list.component.html',
  styleUrls: ['./similar-items-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimilarItemsListComponent {
  relatedToTypeEnum = RelatedToType;

  @Input() relatedToType: RelatedToType;
  @Input() similarItems: Partial<Project | Property | Company | Contact>[] = [];

  @Output() onNavigate = new EventEmitter<Partial<Project | Property | Company | Contact>>();
}
